import React, { Fragment } from 'react';
import Kammerkollegiet from 'components/svg/logos/payments/KammarkollegietComponent';
import Klarna from 'components/svg/logos/payments/KlarnaComponent';
import Mastercard from 'components/svg/logos/payments/MastercardComponent';
import Nets from 'components/svg/logos/payments/NetsComponent';
import Visa from 'components/svg/logos/payments/VisaComponent';
import Trustly from 'components/svg/logos/payments/TrustlyComponent';
import Ideal from 'components/svg/logos/payments/IdealComponent';
import PayPalLogoComponent from 'components/svg/logos/payments/PayPalLogoComponent';
import {
  KAMMERKOLLEGIET,
  KLARNA,
  MASTERCARD,
  SCHEME,
  TRUSTLY,
  VISA,
  NETS,
  IDEAL,
  ONLINE_BANKING_PL,
  PAY_PAL,
  APPLEPAY,
  MOBILEPAY,
  PAY_PO,
  CREDIT_CARD,
  BLIK,
} from 'state/checkoutPage/paymentAdyen/constants/providerTypes';
import OnlineBankingPLComponent from 'components/svg/logos/payments/OnlineBankingPlComponent';
import ApplePayComponent from 'components/svg/logos/payments/ApplePayComponent';
import MobilePayComponent from 'components/svg/logos/payments/MobilePayComponent';
import PayPoComponent from 'components/svg/logos/payments/PayPoComponent';
import BlikComponent from 'components/svg/logos/payments/BlikComponent';

export const getLogo = (paymentType) => {
  switch (paymentType) {
    case KLARNA:
      return <Klarna key='kla' white />;
    case KAMMERKOLLEGIET:
      return <Kammerkollegiet key='kam' white />;
    case MASTERCARD:
      return <Mastercard key='mas' white />;
    case VISA:
      return <Visa key='vis' white />;
    case NETS:
      return <Nets key='net' white />;
    case TRUSTLY:
      return <Trustly key='tru' />;
    case IDEAL:
      return <Ideal key='ide' white />;
    case ONLINE_BANKING_PL:
      return <OnlineBankingPLComponent key='onpl' white />;
    case APPLEPAY:
      return <ApplePayComponent key='app' />;
    case SCHEME:
    case CREDIT_CARD:
      return (
        <Fragment key='vis-mas'>
          <Visa key='vis' white />
          <Mastercard key='mas' white />
          <Klarna key='kla' white />
        </Fragment>
      );
    case PAY_PAL:
      return <PayPalLogoComponent key='ppal' white />;
    case MOBILEPAY:
      return <MobilePayComponent key='mobpay' white />;
    case PAY_PO:
      return <PayPoComponent key='paypo' white />;
    case BLIK:
      return <BlikComponent key='blik' white />;
    default:
      return null;
  }
};
